import MainNav from '../components/MainNav';

new MainNav();
